import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {useTranslation} from "react-i18next";

function DemoShopModal() {
    const [show, setShow] = useState(true);

    const {t} = useTranslation();

    function handleClose() {
        setShow(false);
    }

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('demo_shop_modal_title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {t('demo_shop_modal_content')}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        {t('ok')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DemoShopModal;
